import React from "react";
import { Link } from "react-router-dom";

import NavBar from "../../components/NavBar/NavBar";
import Prefer from "../../components/Prefer/Prefer";
import InstantQuote from "../../components/InstantQuote/InstantQuote";
import Footer from "../../components/Footer/Footer";

import Language1 from "../../images/language1.png";
import Language2 from "../../images/language2.png";

import "./Language.css";

const Language = () => {
  return (
    <div className="language">
      <NavBar white languages />
      <div className="language__hero container">
        <div>
          <h1 className="font-heading">
            See Our Wide <span>Range Of Languages</span>
          </h1>
          <p className="font-normal mt-20">
            Our Solutions are ever availbale to serve your need as we provide
            easy access to meet every of your need. We will never do lesser.
          </p>
          <Link
            className="d-block mt-20 py-20 px-40 text-center font-bold font-bigger"
            to="/quote"
          >
            Instant Quote
          </Link>
        </div>
      </div>
      <div className="language__services container mt-40">
        <div className="language__services__top mt-20 text-center">
          <h2 className="font-heading font-bolder">
            Numerous Languages Are Available
          </h2>
          <p className="font-heavy mt-20">
            Our Solutions are ever availbale to serve your need as we provide
            easy access to meet every of your need. We will never do lesser.
          </p>
        </div>
        <div className="language__services__body d-flex flex-row-reverse align-center justify-center">
          <div className="language__image">
            <img src={Language1} alt="" />
          </div>
          <div className="language__services__list">
            <div>
              <h2>We Render Our Services in</h2>
              <h3>Divers Languages</h3>
              <p>
                We render services in various languages. We provide translation
                services to our clients and are also the best language
                interpretation company. We render services in various languages
                including English, Spanish, French, Italian, Russian and
                Chinese. Our translators are native speakers of these languages
                and have years of experience under their belt. Our translators
                are highly skilled professionals who have a deep understanding
                of the nuances of language. They can translate anything from a
                business document to a legal document to an academic paper.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="language__list p-40">
        <h1 className="font-heading mb-5">Numerous Languages Are Available</h1>
        <p className="font-big font-heavy mt-10 mb-40 pb-20">
          Our Solutions are ever availbale to serve your need as we provide easy
          access to meet every of your need. We will never do lesser.
        </p>
        <div className="language__languages">
          <Link to="/translation/arabic-translation">
            Arabic Translation Service
          </Link>
          <Link to="/translation/chinese-translation">
            Chinese Translation Service
          </Link>
          <Link to="/translation/dutch-translation">
            Dutch Translation Service
          </Link>
          <Link to="/translation/french-translation">
            French Translation Service
          </Link>
          <Link to="/translation/german-translation">
            German Translation Service
          </Link>
          <Link to="/translation/greek-translation">
            Greek Translation Service
          </Link>
          <Link to="/translation/russian-translation">
            Russian Translation Service
          </Link>
          <Link to="/translation/spanish-translation">
            Spanish Translation Service
          </Link>
          <Link to="/translation/portugese-translation">
            Portugese Translation Service
          </Link>
          <Link to="/translation/polish-translation">
            Polish Translation Service
          </Link>
          <Link to="/translation/croatian/united-states-of-america">
            Croatian Translation Service
          </Link>
          <Link to="/translation/czech/united-states-of-america">
            Czech Translation Service
          </Link>
          <Link to="/translation/danish/united-states-of-america">
            Danish Translation Service
          </Link>
          <Link to="/translation/haitian/united-states-of-america">
            Haitian Translation Service
          </Link>
          <Link to="/translation/indonesian/united-states-of-america">
            Indonesian Translation Service
          </Link>
          <Link to="/translation/irish/united-states-of-america">
            Irish Translation Service
          </Link>
          <Link to="/translation/italian/united-states-of-america">
            Italian Translation Service
          </Link>
          <Link to="/translation/japanese/united-states-of-america">
            Japanese Translation Service
          </Link>
          <Link to="/translation/korean/united-states-of-america">
            Korean Translation Service
          </Link>
          <Link to="/translation/scottish/united-states-of-america">
            Scottish Translation Service
          </Link>
        </div>
      </div>
      <div className="language__services__body d-flex flex-row-reverse align-center justify-center">
        <div className="language__image">
          <img src={Language2} alt="" />
        </div>
        <div className="language__services__list">
          <div>
            <h2>We Give the Best Language</h2>
            <h3>Translation and Interpretation</h3>
            <p>
              Our philosophy is to provide high quality translation services
              while staying affordable and accessible to all. We use technology
              to provide quick and seamless translation of documents into
              multiple languages. We offer over 1000 types of language
              interpreting services such as conference interpretation, video
              interpretation and court interpretation. We also have 24-hour
              emergency call centers from where we can dispatch an interpreter
              for urgent requests. Language translation is the most important
              part of the human communication process, it is essential to any
              global business. We are the best translation service provider for
              any language and our services include translation, interpretation,
              voice-to-text and captioning services. We also provide live
              scanning services for documents and transcripts.
            </p>
          </div>
        </div>
      </div>
      <div className="language__banner container">
        <div>
          <h1 className="font-heavy font-normal">WE ARE READY TO HELP</h1>
          <h2 className="font-heading font-bold mb-40">
            This is not the end, we have more to offer to you.
          </h2>
          <Link to="/contact-us">Talk To Us</Link>
        </div>
      </div>
      <Prefer />
      <div className="container">
        <InstantQuote />
      </div>
      <Footer />
    </div>
  );
};

export default Language;
